import React, { useState } from 'react';
import Select from 'react-select'
import StyledSelect from '../components/StyledSelect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faEraser } from '@fortawesome/free-solid-svg-icons';
import Editor from '@monaco-editor/react';

const topRegexs = [
  { label: 'Match string not containing string', value: '/^((?!badword).)*$/gm' },
  { label: 'Check if a string only contains numbers', value: '/^[0-9]*$/gm' },
  { label: 'Match elements of a url', value: '/^((http[s]?|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+[^#?\s]+)(.*)?(#[\w\-]+)?$/gm' },
  { label: 'Match an email address', value: "/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/igm" },
  { label: 'Validate an ip address', value: '/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gm' },
  { label: 'Match or Validate phone number', value: '/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/gm' },
  { label: 'Match html tag', value: '/<\s*a[^>]*>(.*?)<\s*/\s*a>/g' },
  { label: 'Match dates (M/D/YY, M/D/YYY, MM/DD/YY, MM/DD/YYYY)', value: '/^((0?[13578]|10|12)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[01]?))(-|\/)((19)([2-9])(\d{1})|(20)([01])(\d{1})|([8901])(\d{1}))|(0?[2469]|11)(-|\/)(([1-9])|(0[1-9])|([12])([0-9]?)|(3[0]?))(-|\/)((19)([2-9])(\d{1})|(20)([01])(\d{1})|([8901])(\d{1})))$/gm' },
  { label: 'Empty String', value: '/^(\w+\S+)$/' },
  { label: 'Checks the length of number and not starts with 0', value: '/^((?!(0))[0-9]{9})$/g' },
  { label: 'Not Allowing Special Characters', value: '/\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|\s/g' },
  { label: 'Match a valid hostname', value: '/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/gm' },
  { label: 'Validate datetime', value: '/^\d\d\d\d-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01]) (00|[0-9]|1[0-9]|2[0-3]):([0-9]|[0-5][0-9]):([0-9]|[0-5][0-9])$/g' },
  { label: 'String between quotes + nested quotes', value: '/("([^"]|"")*")/g' },
  { label: 'Match brackets', value: '/\(([^)]+)\)/' },
  { label: 'Find URL in text', value: '/(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm' },
  { label: 'Match a wide range of international phone number', value: '/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/g' },
  { label: 'Match IPv6 Address', value: '/(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/gm' },
  { label: 'Email validation', value: '/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i' },
  // { label: 'Allowing Number Only', value: '/^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/g' },
]

const RegexTester = (props) => {
  const { editorTheme, appTheme } = props
  const [regex, setRegex] = useState('');
  const [input, setInput] = useState('');
  const [matches, setMatches] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    setRegex(option.value)
    setMatches([]);
  };

  const handleRegexChange = (e) => {
    setRegex(e.target.value);
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleReset = () => {
    setInput('');
    setRegex('');
    setSelectedOption(null);
    setMatches([]);
  }

  const handleTestRegex = () => {
    try {
      const regexPattern = new RegExp(regex.slice(1, -3), 'g');
      
      const matchedStrings = input.match(regexPattern);
      if (matchedStrings) {
        setMatches(matchedStrings);
      } else {
        setMatches([]);
      }
    } catch (error) {
      console.error('Error occurred while testing regex:', error);
      // Handle the error here, e.g. display an error message to the user
    }
  };

  const displayResults = () => {
    let results = '';
    matches.map((match, index) =>  {
      results += match + '\n';
    })
    return results
  }

  return (
    <div className="grid grid-cols-1 my-4 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="h-screen p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Regex Pattern Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <label
              htmlFor="regex"
              className="block text-sm font-bold text-gray-700 dark:text-white">
              Top Regex Pattern
            </label>
            <br />
            <StyledSelect appTheme={appTheme} value={selectedOption} options={topRegexs} onChange={handleSelectChange} />
            <br />
            <br />
            <label
              htmlFor="regex"
              className="block text-sm font-bold text-gray-700 dark:text-white">
              Regex Pattern
            </label>
            <br />
            <input
              type="text"
              placeholder="Enter regex pattern"
              value={regex}
              onChange={handleRegexChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
            <br />
            <label
              htmlFor="input"
              className="block text-sm text-gray-700 dark:text-white font-bold">
              Input String  (e.g. "Hello World")
            </label>
            <br/>
            <Editor
              value={input}
              height="30vh"
              language="text"
              onChange={(value, event) => setInput(value)}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
        </div>
      </div>
      <div className="col-span-2 xl:col-auto">
        <div className="h-screen p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Test Regex</h3>
          </div>
          <div className="px-4 py-2 text-gray-600 rounded dark:border-gray-600">
            <label
              htmlFor="input"
              className="block text-sm text-gray-700 dark:text-white font-bold">
              Result
            </label>
            <br/>
            <Editor
              value={displayResults()}
              height="60vh"
              language="text"
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
            <button
              onClick={handleReset}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
            &nbsp;&nbsp;
            <button
              onClick={handleTestRegex}
              type="button"
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faPaperPlane}/>
              &nbsp; Run
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegexTester;
